"use strict";

var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _get = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/get.js").default;
var _getPrototypeOf = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _domhandler = require("domhandler");
var _domUtils = require("./dom-utils");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DomHandler = /*#__PURE__*/function (_domhandler$DomHandle) {
  _inherits(DomHandler, _domhandler$DomHandle);
  var _super = _createSuper(DomHandler);
  function DomHandler(options) {
    var _this;
    _classCallCheck(this, DomHandler);
    _this = _super.call(this, undefined, options, undefined);
    _defineProperty(_assertThisInitialized(_this), "ignoredTags", void 0);
    _defineProperty(_assertThisInitialized(_this), "ignoredTagsCount", -1);
    _defineProperty(_assertThisInitialized(_this), "visitors", void 0);
    var ignoredTags = {};
    var _iterator = _createForOfIteratorHelper(options.ignoredTags || []),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tag = _step.value;
        ignoredTags[tag] = true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    _this.ignoredTags = ignoredTags;
    _this.visitors = options.visitors || {};
    var isIgnored = _this.isIgnored.bind(_assertThisInitialized(_this));
    if (options.ignoreNode) {
      _this.isIgnored = function (node) {
        return isIgnored(node) || options.ignoreNode(node, _this.tagStack[_this.tagStack.length - 1]);
      };
    }
    return _this;
  }
  _createClass(DomHandler, [{
    key: "isIgnored",
    value: function isIgnored(node) {
      return this.ignoredTags[node.name] || this.ignoredTagsCount > -1;
    }
  }, {
    key: "addNode",
    value: function addNode(node) {
      if (this.isIgnored(node) === true) {
        // increment only for elements.
        if ((0, _domUtils.isDomElement)(node)) {
          this.ignoredTagsCount++;
        }
      } else {
        _get(_getPrototypeOf(DomHandler.prototype), "addNode", this).call(this, node);
        if ((0, _domUtils.isDomText)(node)) {
          var _this$visitors$onText, _this$visitors;
          (_this$visitors$onText = (_this$visitors = this.visitors).onText) === null || _this$visitors$onText === void 0 ? void 0 : _this$visitors$onText.call(_this$visitors, node);
        }
      }
    }
  }, {
    key: "ontext",
    value: function ontext(text) {
      // Only include text when out of an
      // ignoring session.
      if (this.ignoredTagsCount < 0) {
        _get(_getPrototypeOf(DomHandler.prototype), "ontext", this).call(this, text);
      }
    }
  }, {
    key: "onopentag",
    value: function onopentag(name, attribs) {
      _get(_getPrototypeOf(DomHandler.prototype), "onopentag", this).call(this, name, attribs);
    }
  }, {
    key: "onclosetag",
    value: function onclosetag() {
      var _this$visitors$onElem, _this$visitors2;

      // Call onElement on close to give access to this node children
      (_this$visitors$onElem = (_this$visitors2 = this.visitors).onElement) === null || _this$visitors$onElem === void 0 ? void 0 : _this$visitors$onElem.call(_this$visitors2, this.tagStack[this.tagStack.length - 1]);
      _get(_getPrototypeOf(DomHandler.prototype), "onclosetag", this).call(this);
      if (this.ignoredTagsCount > -1) {
        this.ignoredTagsCount--;
      }
    }
  }, {
    key: "onend",
    value: function onend() {
      var _this$visitors$onDocu, _this$visitors3;
      (_this$visitors$onDocu = (_this$visitors3 = this.visitors).onDocument) === null || _this$visitors$onDocu === void 0 ? void 0 : _this$visitors$onDocu.call(_this$visitors3, this.root);
    }
  }]);
  return DomHandler;
}(_domhandler.DomHandler);
exports.default = DomHandler;